import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  RepoContact,
} from '../../models/repo-business/repo-business.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { RepocontactEditComponent } from '../repocontact-edit/repocontact-edit.component';

@Component({
  selector: 'app-repo-contacts-popup',
  templateUrl: './repo-contacts-popup.component.html',
  styleUrls: ['./repo-contacts-popup.component.scss'],
})
export class RepoContactsPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() public contact: RepoContact;
  @Input() public isUSA: boolean;
  @ViewChild('repoContactEdit') repoContactEdit: RepocontactEditComponent;

  constructor(
    public readonly modal: NgbActiveModal,
  ) {
    super();
  }

  public contactSaved(contact: RepoContact): void {
    this.modal.close(JSON.stringify(contact));
  }

  public dismissPopup(): void {
    this.modal.dismiss(JSON.stringify(this.contact));
  }

  public saveContact() {
    this.repoContactEdit?.submitForm();
  }
  public ngOnInit(): void {

  }
}
